import { Component, Input, OnInit } from '@angular/core';
import { ITableModel } from '../table/model/tableModel';
import { CommonService } from '../../services/commen/commen.services';
import { Http } from '@angular/http';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { TranslateConfigService } from '../../../theme/home/translateConfig.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';
import { Helpers } from '../../../helpers';
const LNG_KEY = "SELECTED_LANGUAGE";

@Component({
  selector: 'app-attachments-list',
  templateUrl: './attachment-list.component.html',
  styleUrls: ['./attachment-list.component.scss']
})
export class AttachmentListComponent implements OnInit {

  static that: AttachmentListComponent;
  selectedLang: any;
  selectedCountry: any;
  isList: boolean;
  tableDetails: ITableModel = {
    data: [],
    columnDetails: [
      { columnName: 'fileName', dataFieldName: 'fileFullName', divType: 'file' },
      { columnName: 'Uploaded Date', dataFieldName: 'updatedDate' },
      { columnName: 'Size', dataFieldName: 'size', },
      { columnName: 'fileAction', dataFieldName: '', divType: 'fileAction' },
    ],
    isColumnNameShow: false
  };
  @Input() DocumentId: any;
  @Input() DocumentType: any;
  documentList: any[];

  constructor(
    private commonService: CommonService,
    private anghttp: Http,
    private _appService: appService,
    private toastr: ToastrService,
    private http: HttpClient,
    private service: TranslateConfigService,
    private translate: TranslateService,
  ) {
    AttachmentListComponent.that = this;
    let language = this.translate.getBrowserLang();
    let value = localStorage.getItem(LNG_KEY);
    if (value === "" || value === null || value === undefined) {
      this.translate.setDefaultLang(language);
      this.selectedLang = language;
    } else {
      this.service.setLanguage(value);
      this.selectedLang = value;
    }
    let val = localStorage.getItem(LNG_KEY);
  }

  ngOnInit() {
    this.getAttachedDocument();
  }

  getAttachedDocument(id = this.DocumentId, type = this.DocumentType) {
    Helpers.setLoading(true);
    this._appService
      .GetByTwoId("Common", "GetDocumentListById", id, type)
      .subscribe((response) => {
        if (response) {
          response.map(x => {
            x.fileFullName = x.FileName ? (x.FileName.split("_")[1] + '.' + x.FileExtension) : null;
            x.FilePath = environment.apiUrl + x.docPath;
          })
        }
        this.documentList = response;
        this.tableDetails.data = this.documentList;
        Helpers.setLoading(false);
      },
        (err) => {
          Helpers.setLoading(false);
          var ErrorMsg = this.translate.instant("READYTODISPATCH.Erroroccurred");
          this.toastr.error(ErrorMsg, "error");
        })
  }

  downloadFile(event) {
    const fileUrl = event;
    this.http
      .get(fileUrl, { responseType: 'blob' })
      .subscribe((response: any) => {
        const blob = new Blob([response], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'filename.pdf'; // Set desired filename
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      });
  }

  onActionClick({ row, actionName }) {
    if (actionName == 'download') {
      this.downloadFile(row.FilePath)
    } else {
      this.deleteFile(row);
    }
  }

  deleteFile(row: any) {
    this.commonService.deleteFileId(row.Id)
      .then((data) => {
        const index = this.documentList.findIndex(x => x.Id === row.Id);
        if (index !== -1) {
          this.documentList.splice(index, 1);
        }
        this.tableDetails.data = this.documentList;
      })
      .catch((error) => {
        console.error(error);
      });
  }

  onFileSelected(event: any): void {
    const files = (event.target as HTMLInputElement).files;
    const todaysDate = this.commonService.formatSelectedDate(new Date());
    if (!files || files.length === 0) {
      this.toastr.error(this.translate.instant("Attachment.UploadFileError"), "error");
      return;
    }
    for (const file of Array.from(files)) {
      if (this.commonService.isValidFileTypeV2(file) && this.commonService.isFileSizeExceeded(file) && this.commonService.isValidFileName(file)) {
        this.tableDetails.data.unshift({
          fileFullName: file.name, updatedDate: todaysDate, size: Math.floor(file.size / 1024) + 'KB'
        });
        this.UploadDocument(file);
        this.tableDetails = { ...this.tableDetails, data: this.tableDetails.data }
      }
    }
  }

  UploadDocument(event, type: any = this.DocumentType) {
    const selectedFile = event;
    const { formData, options } = this.commonService.setHeaderAndOptionsForFileUpload(selectedFile);
    const apiUrl =
      environment.apiUrl +
      "/api/Document/UploadAttachment?ReferenceId=" +
      this.DocumentId +
      "&TransectionType=" +
      type +
      "&ParentId=" +
      null;
    const req1 = this.anghttp.post(apiUrl, formData, options).subscribe(
      (response) => {
        this.toastr.success(
          this.translate.instant("Attachment.AttachmentUploadSuccess"),
          "success"
        );
      },
      (err) => {
        this.toastr.error(this.translate.instant("Attachment.UploadError"), "error");
      }
    );
  }

}
